<template>
  <vx-modal
    :title="
      !form.uuid ? $t('messages.create.title') : $t('messages.edit.title')
    "
    :active.sync="show"
  >
    <form v-on:submit="preventSubmit($event)" @keydown="form.onKeydown($event)">
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('programs.labels.title')"
              name="title"
              class="w-full"
              v-model="form.title"
            />
            <has-error :form="form" field="title" />
          </div>
        </div>
      </div>
      <div class="sm:w-12/12">
        <div class="vx-row my-5">
          <div class="vx-col w-full">
            <label for="image" class="vs-input--label">{{
              $t('programs.labels.cover')
            }}</label>
            <input
              id="cover"
              name="cover"
              type="file"
              ref="cover"
              @change="changeInputFile"
              class="vs-input--input"
            />
            <has-error :form="form" field="cover" />
            <div v-if="form.cover_url !== ''" class="text-center mt-4">
              <img
                :src="form.cover_url"
                alt="cover_url"
                loop="infinite"
                style="width: 200px"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('programs.labels.features')"
              name="features"
              class="w-full"
              ref="features"
              v-model="feature_text"
              v-on:keyup.enter="addFeature($event)"
            />
            <has-error :form="form" field="features" />
            <vs-list v-if="form.features.length > 0">
              <vs-list-item
                v-for="(feature, index) in form.features"
                :key="index"
                :subtitle="feature"
              >
                <vs-button
                  color="danger"
                  size="small"
                  @click="removeFeature(index)"
                  >X</vs-button
                >
              </vs-list-item>
            </vs-list>
          </div>
        </div>
      </div>
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('programs.labels.price')"
              name="price"
              class="w-full"
              v-model="form.price"
            />
            <has-error :form="form" field="price" />
          </div>
        </div>
      </div>
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <label for="myQuillEditor" class="vs-input--label">
              {{ $t('programs.labels.content') }}
            </label>
            <quill-editor
              class="editor"
              ref="myQuillEditor"
              v-model="form.content"
              :options="options"
            ></quill-editor>
            <has-error :form="form" field="content" />
          </div>
        </div>
      </div>
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-card>
              <vs-row class="justify-content-between py-5 align-items-center">
                <vs-col
                  vs-lg="4"
                  vs-sm="12"
                  vs-xs="12"
                  class="d-flex align-items-center"
                >
                  <h2 class="pt-3">{{ $t('programs.labels.routines_id') }}</h2>
                </vs-col>
                <vs-divider></vs-divider>
              </vs-row>
              <vs-row class="justify-end">
                <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
                  <vx-select
                    :model.sync="routine"
                    :label="$t('programs.labels.select_routines_id')"
                    :options="routines"
                    :translate="false"
                    :uuid="false"
                    class="w-full abs"
                  ></vx-select>
                  <has-error :form="form" field="routines_id" />
                </vs-col>
                <vs-col
                  vs-lg="4"
                  vs-sm="12"
                  vs-xs="12"
                  class="pt-4 text-center"
                >
                  <vs-button
                    class="md:mb-0"
                    v-on:click="addRoutine(routine)"
                    button="button"
                  >
                    {{ $t('programs.labels.add') }}
                  </vs-button>
                </vs-col>
              </vs-row>
              <vs-row
                vs-justify="center"
                vs-w="12"
                class="relative"
                v-if="form.routines.length > 0"
              >
                <vs-list class="cursor-move">
                  <draggable v-model="form.routines">
                    <transition-group>
                      <vs-list-item
                        class="list-item"
                        v-for="(routine, index) in form.routines"
                        :key="routine.id + '' + index"
                        :subtitle="routine.name"
                      >
                        <div class="flex align-items-center justify-between">
                          <div class="vs-con-input">
                            <input
                              :name="'price-routine' + index"
                              class="w-1/2 vs-inputx vs-input--input normal"
                              :disabled="true"
                              :value="formatter.format(routine.product.price)"
                            />
                          </div>
                          <vs-button
                            color="danger"
                            size="small"
                            @click="removeRoutine(index)"
                            >X</vs-button
                          >
                        </div>
                      </vs-list-item>
                    </transition-group>
                  </draggable>
                </vs-list>
              </vs-row>
            </vs-card>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap justify-between">
        <div class="mb-6 md:mb-0 mr-4"></div>

        <div class="mb-6 flex flex-wrap justify-between">
          <vs-button class="md:mb-0" v-if="!form.uuid" @click="save()">
            {{ $t('messages.create.title') }}
          </vs-button>
          <vs-button class="md:mb-0" v-else @click="save()">
            {{ $t('messages.edit.title') }}
          </vs-button>
        </div>
      </div>
    </form>
  </vx-modal>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Form from 'vform'
import draggable from 'vuedraggable'
export default {
  data() {
    return {
      form: new Form({
        uuid: null,
        title: '',
        features: [],
        routines_id: [],
        routines: [],
        price: 0,
        cover: '',
        cover_url: '',
        content: ''
      }),
      options: {
        placeholder: '',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean']
          ]
        }
      },
      routines: [],
      feature_text: '',
      routine: null,
      disableButton: false,
      show: false,
      FormDataErrors: null,
      formatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.clearForm()
      }
    },
    FormDataErrors: {
      handler(error) {
        // eslint-disable-next-line eqeqeq
        if (error != null) {
          this.form.errors.set(this.form.extractErrors(error.response))
        }
      }
    }
  },
  components: {
    draggable
  },
  methods: {
    async showModal() {
      this.show = true
    },
    save() {
      if (this.form.uuid) {
        this.edit()
      } else {
        this.create()
      }
    },
    async create() {
      let message_title = null
      let message_content = null
      let message_type = null
      const vm = this
      try {
        this.disableButton = true

        this.$vs.loading()
        const formData = new FormData()
        formData.append('_method', 'post')
        this.setData(formData)
        // eslint-disable-next-line no-unused-vars
        const { data } = await axios
          .post(`${process.env.VUE_APP_API_URL}/api/programs`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .catch(function (err) {
            vm.$vs.loading.close()
            vm.FormDataErrors = err
          })
        this.$parent.getPrograms()
        this.$vs.loading.close()

        message_type = 'success'
        message_content = this.$t(
          'messages.create.messages.success_description'
        )

        message_title = this.$t('messages.create.messages.success')
        this.showMessage(message_type, message_title, message_content)
        this.show = false
        this.clearForm()
      } catch (exception) {
        this.$vs.loading.close()
        console.log('Ocurrió un error:', exception)
      }
      this.disableButton = false
    },
    async edit() {
      let message_title = null
      let message_content = null
      let message_type = null
      const vm = this
      try {
        this.disableButton = true
        vm.$vs.loading()

        const formData = new FormData()
        this.setData(formData)
        formData.append('_method', 'patch')
        // eslint-disable-next-line no-unused-vars
        const { data } = await axios
          .post(
            `${process.env.VUE_APP_API_URL}/api/programs/${this.form.uuid}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          .catch(function (err) {
            vm.$vs.loading.close()
            vm.FormDataErrors = err
          })
        this.$parent.getPrograms()
        this.$vs.loading.close()
        this.form = Object.assign(this.form, data)
        message_type = 'success'
        message_content = this.$t('messages.edit.messages.success_description')
        message_title = this.$t('messages.edit.messages.success')
        this.showMessage(message_type, message_title, message_content)

        this.show = false
        this.clearForm()
      } catch (exception) {
        this.$vs.loading.close()
        console.log('Ocurrió un error:', exception)
      }
      this.disableButton = false
    },
    async getProgram(uuid) {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/programs/${uuid}`
        )
        this.form = _.assign(this.form, data)
        this.form.cover_url = data.cover
        this.form.cover = ''
        this.form.price = data.product.price
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    async getRoutines() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/programs/routines`
        )

        this.routines = _.xorBy(data, this.form.routines, 'id')
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    showMessage(message_type, message_title, message_content) {
      Swal.fire({
        icon: message_type,
        title: message_title,
        text: message_content,
        confirmButtonText: this.$t('ok')
      })
    },
    clearForm() {
      this.form = _.assign(this.form, {
        uuid: null,
        title: '',
        features: [],
        routines_id: [],
        routines: [],
        price: 0,
        cover: '',
        cover_url: '',
        content: '',
      })
      this.routines = []
      this.feature_text = ''
      this.routine = null
      this.form.clear()
      this.FormDataErrors = null
      this.$refs.cover.value = null
    },
    changeInputFile(image) {
      if (image.target.files.length > 0) {
        const file = image.target.files[0]
        this.form.cover = file
        this.form.cover_url = URL.createObjectURL(file)
      }
    },
    preventSubmit(event) {
      event.preventDefault()
    },
    addFeature(event) {
      event.preventDefault()
      if (event.target.value !== '' && this.form.features.length === 5) {
        this.FormDataErrors = {
          response: {
            data: {
              errors: {
                features: ['características no debe tener más de 5 elementos']
              }
            }
          }
        }
        this.feature_text = ''
      }
      if (event.target.value !== '' && this.form.features.length < 5) {
        this.form.features.push(event.target.value)
        this.feature_text = ''
      }
    },
    addRoutine(routine_id) {
      if (routine_id !== null && routine_id !== '') {
        this.form.routines.push(
          _.find(this.routines, function (routine) {
            return routine.id === routine_id
          })
        )
        this.routines = _.remove(this.routines, function (routine) {
          return routine.id !== routine_id
        })
      }

      this.routine = null
    },
    removeFeature(index) {
      this.form.features.splice(index, 1)
    },
    removeRoutine(index) {
      const routine = this.form.routines.splice(index, 1)
      this.routines.push(routine[0])
    },
    setData(formData) {
      this.form.routines_id = _.map(this.form.routines, function (routine) {
        return routine.id
      })
      for (const key in this.form) {
        if (key === 'routines_id') {
          for (let index = 0; index < this.form[key].length; index++) {
            formData.append('routines_id[]', this.form[key][index])
          }
        } else if (key === 'features') {
          for (let index = 0; index < this.form[key].length; index++) {
            formData.append('features[]', this.form[key][index])
          }
        } else {
          formData.append(key, this.form[key])
        }
      }
    }
  }
}
</script>
<style lang="scss">
.cursor-move {
  cursor: move !important;
}
</style>
